/**
 * Treatment Plan types
 */

export enum TreatmentPlanStatus {
  GeneratingTriggered = -1,
  Generating = 0,
  AIDrafted = 1,
  AwaitingProviderReview = 2,
  AwaitingPatientConfirmation = 3,
  DeclinedByPatient = 4,
  ApprovedByPatient = 5,
  InProgress = 6,
  Completed = 7,
  GenerationFailed = 8,
}

// CDT code suggestion within a step
export interface CodeSuggestion {
  id: number;
  cdtCodeId: number;
  code: string;
  description: string;
  defaultFee: number;
}

// Treatment step (procedure) within an appointment
export interface TreatmentStep {
  id: number;
  text: string;
  sortOrder: number;
  codeSuggestions: CodeSuggestion[];
}

// Appointment containing multiple steps/procedures
export interface TreatmentAppointment {
  id: number;
  description?: string;
  timeframeLabel: string;
  conditionalPath: string;
  notes: string;
  sortOrder: number;
  steps: TreatmentStep[];
}

export interface TreatmentPlan {
  id: string;
  patientUid: string;
  patientName: string;
  providerName: string;
  title: string;
  status: TreatmentPlanStatus;
  createdAt: string;
  approvedAt?: string;
  approvedBy?: string;
  summary: string;
  appointments: TreatmentAppointment[];
  fee: string;
  completedSteps: number;
}
